import { plainToInstance } from 'class-transformer'
import { ITimeFilter } from '@core/entities/filters'
import { FilterBase } from '@core/entities/filters/FilterBase'
import { TimeFilterOperatorTypes } from '../types'
import moment from 'moment'

export class TimeFilter extends FilterBase<ITimeFilter> {
  propertyType: 'TIME'
  operator: TimeFilterOperatorTypes
  // for is_before | is_after context
  startTime?: string
  // for is_between context
  endTime?: string
  timeValue?: string

  public static new(payload: unknown): TimeFilter {
    return plainToInstance(TimeFilter, payload)
  }

  public getValue(): string {
    const timeString = (time) => moment(time).format('HH:mm')

    const startTimeString = this.startTime ? timeString(this.startTime) : ''
    const endTimeString = this.endTime ? ` - ${timeString(this.endTime)}` : ''

    const timeValueString = this.timeValue ? timeString(this.timeValue) : ''

    return this.timeValue
      ? `${timeValueString}`
      : `${startTimeString}${endTimeString}`
  }
}
